import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/write-now/display_configs/${resource.id}/edit`} />,
    <MenuItem primaryText='Program' key='program' value={`/write-now/programs/${resource.program_id}/edit`} />
  ]
}

export default buildMenuItems
